import { ApolloError } from '@fluentsms/graphql';
import { useSnackbar } from './';
import { useEffect } from 'react';
import { useTranslation } from '@fluentsms/i18n';

export interface useErrorSnackbarProps {
  loading: boolean;
  error?: ApolloError;
}

const containsErrorCode = (error: ApolloError, errorCode: number): boolean => {
  return error.graphQLErrors?.some((error) => error.extensions?.code === errorCode);
};

const useErrorSnackbar = ({ loading, error }: useErrorSnackbarProps): void => {
  const { t } = useTranslation(['common']);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (loading || !error) {
      return;
    }

    if (containsErrorCode(error, 409)) {
      enqueueSnackbar(t('common:snackbar.changeError'), {
        variant: 'warning',
      });
    } else {
      enqueueSnackbar(t('common:snackbar.genericError'), {
        variant: 'error',
      });
    }

    return;
  }, [loading, error]);
  return;
};

export default useErrorSnackbar;
